/**
 * Button 컴포넌트
 * @description 앱 디자인 시스템 `Button` 의 웹 포팅. 앱의 `Button.design.md` 가 원본이며,
 *   토큰에 없는 키는 빈 곳이 아니라 스펙이다 — `content` 는 `rest`·`disabled` 뿐이라 눌린
 *   동안에도 글자색이 그대로다. 앱은 `hovered` 를 쓰지 않지만(터치) 웹은 쓴다.
 * @example
 * <Button text="Apply" tone="brand" radius="circle" onClick={apply} />
 * <Button text="Retry" tone="outlined" size="sm" />
 */
import { memo } from "react";

import { buttonStyles } from "./Button.styles";
import type { ButtonProps } from "./Button.types";

const Button = memo<ButtonProps>(
  ({
    text,
    tone,
    size,
    radius,
    fullWidth,
    leadingIcon,
    trailingIcon,
    className,
    type = "button",
    ...rest
  }) => (
    <button
      type={type}
      className={buttonStyles({ tone, size, radius, fullWidth, className })}
      {...rest}
    >
      {leadingIcon}
      {/* 라벨은 한 줄로 자른다 — 긴 문구가 버튼을 두 줄로 밀지 않게 */}
      <span className="truncate">{text}</span>
      {trailingIcon}
    </button>
  ),
);

Button.displayName = "Button";

export default Button;
